import { INFO_APPEARANCE, makeFlag, makeFlagDescription } from '../../records/Flag';
import { foldInstallMode } from '../../records/InstallMode/InstallMode';
import { isInstallStatusLoading } from '../../records/InstallMode/InstallStatus';
import { addFlag } from '../Flags';
export const SET_INSTALL_MODE = 'INSTALLATION_SET_INSTALL_MODE';
export const CLEAR_INSTALL_MODE = 'INSTALLATION_CLEAR_INSTALL_MODE';
const setInstallMode = _ref => {
  let {
    installMode
  } = _ref;
  return {
    type: SET_INSTALL_MODE,
    installMode
  };
};
export const clearInstallMode = () => ({
  type: CLEAR_INSTALL_MODE
});
export const NO_SIMULTANEOUS_INSTALLS_FLAG_KEY = 'no-simultaneous-installs-allowed';
export const doSetInstallMode = _ref2 => {
  let {
    installMode
  } = _ref2;
  return (dispatch, getState) => {
    getState().installation.installMode.fold(() => dispatch(setInstallMode({
      installMode
    })), cim => foldInstallMode(cim)(() => true, appSpecificPasswordInstallMode => appSpecificPasswordInstallMode.appSpecificPassword.forAll(asp => !isInstallStatusLoading(asp.status)), () => true, installableAppDefaultInstallMode => !isInstallStatusLoading(installableAppDefaultInstallMode.status), installableAppByManualUrlInstallMode => installableAppByManualUrlInstallMode.installableAppByManualUrl.forAll(asp => !isInstallStatusLoading(asp.status)), installableAppUpgradeInstallMode => !isInstallStatusLoading(installableAppUpgradeInstallMode.status)) ? dispatch(setInstallMode({
      installMode
    })) : dispatch(addFlag({
      flag: makeFlag({
        key: NO_SIMULTANEOUS_INSTALLS_FLAG_KEY,
        appearance: INFO_APPEARANCE,
        autoDismiss: true,
        description: makeFlagDescription({
          primary: 'Another installation is still in progress... Try again when it is complete.'
        }),
        title: 'Hold on!'
      })
    })));
  };
};